<p-dialog
  [appendTo]="appendTo || 'body'"
  [baseZIndex]="20000"
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: 'min(96vw, 1320px)' }"
  styleClass="fdd-dialog"
  (onHide)="onHide()"
>
  <ng-template pTemplate="header">
    <div class="fdd-dialog-header-inner p-dialog-title">
      <div class="fdd-dialog-header-title">{{ fieldDisplayName }}</div>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="fdd-dialog-content-wrap">
    @if (isLoading) {
      <div class="fdd-modal-loader">
        <app-loading [loading]="true"></app-loading>
      </div>
    }
    @if (!isLoading) {
      <div class="fdd-shell-tabs">
        <app-tabs
          [tabs]="shellTabs"
          [activeTab]="shellActiveTab"
          (tabChanged)="onShellTabChange($event)"
        ></app-tabs>
      </div>
    }
    </div>
  </ng-template>

  <ng-template #indicesTabTpl>
    @if (customField && field) {
      <app-field-details-indices-tab
        [field]="field"
        [customField]="customField"
        [fieldPolygonJson]="fieldPolygonJson"
        [fieldCenter]="fieldCenter"
        [mapCenter]="mapCenter"
        [dataUpdatedAt]="dataUpdatedAt"
        [regionPathDisplay]="regionPathDisplay"
        (reloadFieldRequest)="reloadFieldDetails()"
      />
    }
  </ng-template>

  <ng-template #meteoTabTpl>
    <div class="fdd-tab-panel fdd-tab-panel--meteo">
      @if (!shellMeteoContentReady) {
        <div class="fdd-tab-lazy-hint muted">{{ 'FIELD_DETAILS_V2.SHELL_TAB_CLICK_TO_LOAD' | translate }}</div>
      } @else if (fieldCenter) {
        <app-point-polygon-details-modal
          [embedded]="true"
          [visible]="true"
          [latitude]="fieldCenter.lat"
          [longitude]="fieldCenter.lng"
          [regionPathString]="fieldRegionDisplay"
          [isOnlyInfo]="true"
          [pointData]="fieldEntity"
        />
      } @else {
        <div class="fdd-empty muted">{{ 'FIELD_DETAILS_V2.METEO_NO_POSITION' | translate }}</div>
      }
    </div>
  </ng-template>

  <ng-template #editTabTpl>
    <div class="fdd-edit-tab-root">
      @if (!shellEditContentReady) {
        <div class="fdd-tab-lazy-hint muted">{{ 'FIELD_DETAILS_V2.SHELL_TAB_CLICK_TO_LOAD' | translate }}</div>
      } @else if (editTabInjector) {
        <ng-container *ngComponentOutlet="editTabComponent; injector: editTabInjector"></ng-container>
      } @else {
        <div class="fdd-edit-tab-loading">
          <app-loading [loading]="true"></app-loading>
        </div>
      }
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    @if (field) {
      <div class="fdd-footer-actions">
        <app-secondary-button icon="pi pi-arrow-right" [title]="'SHOW_MORE'" (action)="onShowMore()"></app-secondary-button>
      </div>
    }
  </ng-template>
</p-dialog>
